module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_8003.78bbec68.png";